module.exports = __webpack_public_path__ + "img/track_caution.0eaae2c4.svg";